import styled from 'styled-components';

import Card from '@src/components/ui/Card';

export const FormCard = styled(Card)`
  margin: ${({ theme }) => theme.spacing[8]};
`;
